"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCanBeThumb = void 0;
var getCanBeThumb = function (fileName) {
    if (!fileName) {
        return false;
    }
    var fileNameParts = fileName.toLowerCase().split('.') || [];
    var fileExtension = fileNameParts.pop();
    return fileExtension === 'jpg' ||
        fileExtension === 'jpeg' ||
        fileExtension === 'png' ||
        fileExtension === 'tiff' ||
        fileExtension === 'webp';
};
exports.getCanBeThumb = getCanBeThumb;
